import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=6d0069f8&"
import script from "./Save.vue?vue&type=script&lang=js&"
export * from "./Save.vue?vue&type=script&lang=js&"
import style0 from "./Save.vue?vue&type=style&index=0&id=6d0069f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports